import * as React from 'react';
var AnchorContext = /*#__PURE__*/React.createContext(null);
export default AnchorContext;